"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FormDispatchContext = void 0;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var design_language_1 = require("@doordash/design-language");
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
var Row_1 = __importDefault(require("./Row"));
var Section_1 = __importDefault(require("./Section"));
var utils_1 = require("./utils");
var styles_1 = require("./styles");
var formStateReducer = function (state, action) {
    var _a;
    return __assign(__assign({}, state), (_a = {}, _a[action.key] = action.value, _a));
};
exports.FormDispatchContext = React.createContext(null);
var Form = function (_a) {
    var name = _a.name, description = _a.description, helperText = _a.helperText, fields = _a.fields, sections = _a.sections, onSubmit = _a.onSubmit, onChange = _a.onChange, handleErrors = _a.handleErrors, customFormStyleElement = _a.customFormStyleElement, customSectionStyleElement = _a.customSectionStyleElement, renderHeaderContent = _a.renderHeaderContent, _b = _a.submitProps, submitProps = _b === void 0 ? {
        submitButtonText: 'Submit',
        isSubmitButtonDisabled: false,
        hideSubmitButton: false
    } : _b, _c = _a.initialData, initialData = _c === void 0 ? {} : _c;
    var areSectionsProvided = !fields && sections;
    var fieldsData = areSectionsProvided ? sections : fields;
    var flattenedFields = utils_1.getFlattenedFields(fieldsData, areSectionsProvided);
    var formConfig = lodash_1.keyBy(flattenedFields, 'key');
    var _d = React.useReducer(formStateReducer, initialData), formState = _d[0], dispatch = _d[1];
    var _e = React.useState({}), errors = _e[0], setErrors = _e[1];
    var _f = React.useState(component_button_1["default"].States.Default), buttonState = _f[0], setButtonState = _f[1];
    React.useEffect(function () {
        utils_1.cleanValidationErrors(formState, errors, setErrors);
        if (buttonState !== component_button_1["default"].States.Default) {
            setButtonState(component_button_1["default"].States.Default);
        }
        if (onChange) {
            onChange(formState, initialData);
        }
    }, [formState]);
    if (!fields && !sections) {
        return (React.createElement(design_language_1.Text, null, "Neither 'fields' or 'sections' prop is specified. Only one of them should be provided."));
    }
    if (fields && sections) {
        return (React.createElement(design_language_1.Text, null, "Both 'fields' and 'sections' props are specified. Only one of them should be provided."));
    }
    if (utils_1.hasDuplicateFields(flattenedFields)) {
        return React.createElement(design_language_1.Text, null, "Duplicate fields found, please ensure key uniqueness");
    }
    var EntryComponent = areSectionsProvided ? Section_1["default"] : Row_1["default"];
    var entries = fieldsData.map(function (entry, index) {
        return (React.createElement(EntryComponent, { key: index, entry: entry, formState: formState, errors: errors, customStyles: customSectionStyleElement }));
    });
    var handleSubmit = function () {
        return utils_1.submitFormAsync(errors, setErrors, setButtonState, onSubmit, formConfig, formState, initialData, handleErrors);
    };
    var CustomFormWrapper = customFormStyleElement || styles_1.DefaultFormWrapper;
    return (React.createElement(exports.FormDispatchContext.Provider, { value: dispatch },
        React.createElement(design_language_1.StackChildren, { size: design_language_1.StackChildren.Sizes.Medium },
            renderHeaderContent ? (renderHeaderContent({ onSubmitHandler: handleSubmit })) : (React.createElement(React.Fragment, null,
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.MajorPageTitle }, name),
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageBody }, description))),
            React.createElement(CustomFormWrapper, null, entries),
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageBody }, helperText),
            !submitProps.hideSubmitButton && (React.createElement(component_button_1["default"], { isInline: true, type: component_button_1["default"].Types.AlternativePrimary, state: buttonState, isDisabled: submitProps.isSubmitButtonDisabled, "data-testid": "form_submit_button", onClick: handleSubmit }, submitProps.submitButtonText)))));
};
Form.defaultProps = {
    description: '',
    helperText: ''
};
exports["default"] = Form;
